import { Color } from "./Color";
import { IColorSpecifiedFeature } from "./IColorSpecifiedFeature";
import { OptionalFeature } from "./OptionalFeature";

export class ColorSpecifiedFeature extends OptionalFeature {
  constructor(isEnable: boolean = false, public color: Color = new Color("transparent")) {
    super(isEnable);
  }

  clone(): ColorSpecifiedFeature {
    return new ColorSpecifiedFeature(
      this.isEnable,
      this.color.clone()
    );
  }

  static from(source: IColorSpecifiedFeature): ColorSpecifiedFeature {
    return new ColorSpecifiedFeature(source.isEnable, Color.from(source.color));
  }

  static to(source: ColorSpecifiedFeature): IColorSpecifiedFeature {
    if (!source) {
      return null;
    }
    return {
      isEnable: source.isEnable,
      color: Color.to(source.color),
    };
  }
}
